// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-share.-white[data-v-13ee8981]{color:#fff;text-shadow:1px 1px 2px rgba(0,0,0,.50196)}@media screen and (min-width:960px){.button-share.-white[data-v-13ee8981]{color:#616161}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
